import type { Asset } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/asset/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

const classificationSection: FormItem<Asset> = {
  colCount: 3,
  cssClass: 'tmm-section',
  caption: 'Classification',
  items: [allFields.assetTypeId, allFields.makeId, allFields.modelId],
};

const costSection: FormItem<Asset> = {
  colCount: 2,
  cssClass: 'tmm-section',
  caption: 'Costs',
  items: [
    allFields.preventiveMaintenanceCost,
    allFields.correctiveMaintenanceCost,
    allFields.acquisitionCostValue,
    allFields.maintenanceCostValue,
    allFields.replacementCost,
  ],
};

const riskAssessmentSection: FormItem<Asset> = {
  colCount: 3,
  cssClass: 'tmm-section',
  caption: 'Risk Assessment',
  items: [
    allFields.condition,
    allFields.usefulLife,
    allFields.replacementYear,
    allFields.riskAssessmentScore,
    { ...allFields.riskScoreDriverNote, colSpan: 2 },
  ],
};

export const updateFields: FormItem<Asset & { traneSupplySearch: unknown }>[] = [
  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 30,
      lg: 30,
    },
    cssClass: 'tmm-section-no-background',
    caption: 'Asset Details',
    items: [
      {
        colCount: 1,
        colSpan: 10,
        items: [allFields.tenantId],
      },
      {
        colCount: 1,
        colSpan: 13,
        items: [allFields.assetTag],
      },
      {
        colCount: 1,
        colSpan: 7,
        items: [allFields.traneSupplySearch],
      },
    ],
  },
  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 3,
      lg: 3,
    },
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        colCount: 1,
        colSpan: 1,
        items: [allFields.image],
      },

      {
        colCount: 1,
        colSpan: 2,
        items: [
          allFields.serialNumber,
          allFields.state,
          allFields.locationId,
          allFields.installDate,
        ],
      },
      {
        colCount: 1,
        colSpan: 3,
        items: [allFields.description],
      },
    ],
  },
  classificationSection,
  costSection,
  riskAssessmentSection,
  getHistorySection(),
];

export const createFields: FormItem<Asset>[] = [
  {
    colCount: 2,
    cssClass: 'tmm-section-no-background',
    caption: 'Asset Details',
    items: [allFields.tenantId, allFields.assetTag],
  },
  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 4,
      lg: 4,
    },
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.image],
      },

      {
        colCount: 1,
        colSpan: 2,
        items: [
          allFields.serialNumber,
          allFields.state,
          allFields.locationId,
          allFields.installDate,
        ],
      },
      {
        colCount: 1,
        colSpan: 4,
        items: [allFields.description],
      },
    ],
  },
  classificationSection,
  costSection,
  riskAssessmentSection,
];
